import { twJoin } from 'tailwind-merge';

import type { Props as BaseButtonProps } from './BaseButton';
import { BaseButton } from './BaseButton';

export const SecondaryButton = ({ className, ...rest }: BaseButtonProps) => {
  return (
    <BaseButton
      {...rest}
      className={twJoin(
        'py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-transparent rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700  dark:text-white dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700',
        className,
      )}
    />
  );
};
// 'bg-transparent text-white hover:bg-gray-100 dark:hover:bg-gray-700 focus-visible:outline-blue-600 border border-gray-200 dark:border-gray-600',
// className
